import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSlidesComponent } from './simple-icons-slides.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSlidesComponent ],
    exports:      [ SimpleIconsSlidesComponent ],
    bootstrap:    []
})
export class SimpleIconsSlidesModule {}
